import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import DetailInfoComponent from "../../../components/detailInfo/detailInfoComponent";
import { SectionModel } from "../../../models/components.model";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";
import { DocumentUrl, Income } from "../../../models/cartable.model";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";
import DivisionIdentityCmp from "../../../components/cards/DivisionIdentityCmp";

let sections: SectionModel[];
sections = [
  { dataKey: "jobTitle", rowCol: 4, title: "عنوان شغل" },
  {
    dataKey: "monthlyIncome",
    rowCol: 4,
    title: "مجموع مبلغ درآمد",
    // dataPostValue: "ریال",
    // hasThousandSeparatorFormat: true,
  },
];

export default function GuarantorIncomeInfo(props: any) {
  return (
    <>
      <DivisionCmp
        child={
          <DetailInfoComponentThumbnail
            sections={sections}
            data={props}
            documentList={props.data}
            title={false}
            height={"20vh"}
            showFooter={false}
            headerHeight={"6vh"}
            align={"center"}
          />
        }
        title={" اطلاعات شغلی"}
        marginTop={"8px"}
      ></DivisionCmp>
    </>
  );
}
